import { createReducer, on } from '@ngrx/store';
import {
  createOrder,
  createOrderFail,
  createOrderSuccess,
  getOrderList,
  getOrderListFail,
  getOrderListSuccess,
  getOrder,
  getOrderFail,
  getOrderSuccess,
} from '@b2b/features/order/core/store/order.actions';
import {
  failStatus,
  GenericRequest,
  initialStatus,
  loadingStatus,
  successStatus,
} from '@core/models/request-status.model';
import { Order, OrderResponse } from '@b2b/features/order/utilities/order.model';

export type OrderState = {
  list: GenericRequest<OrderResponse[]>;
  currentPage: number;
  totalPages: number;
  currentOrder: GenericRequest<Order[] | null>;
};

const initialState: OrderState = {
  list: {
    data: [] as OrderResponse[],
    ...initialStatus,
  },
  currentPage: 1,
  totalPages: 1,
  currentOrder: {
    data: null,
    ...initialStatus,
  },
};

export const orderReducer = createReducer(
  initialState,

  //LIST ORDER HANDLERS
  on(getOrderList, (state: OrderState): OrderState => {
    const response: OrderState = {
      ...state,
      list: {
        ...loadingStatus,
      },
      currentOrder: {
        ...loadingStatus,
      },
    };

    return response;
  }),

  on(getOrderListSuccess, (_state: OrderState, order): OrderState => {
    const response: OrderState = {
      ..._state,
      list: {
        ...successStatus,
        data: order.data,
      },
      currentPage: order.currentPage,
      totalPages: order.totalPages,
    };

    return response;
  }),

  on(getOrderListFail, (_state: OrderState, data: any): OrderState => {
    const response: OrderState = {
      ..._state,
      list: {
        ...initialState,
        ...failStatus,
        message: data.message,
      },
    };

    return response;
  }),

  // CREATE ORDER HANDLERS
  on(createOrder, (_state: OrderState): OrderState => {
    const response: OrderState = {
      ..._state,
      list: {
        ..._state.list,
        ...loadingStatus,
        message: '',
      },
    };

    return response;
  }),

  on(createOrderSuccess, (_state: OrderState, order): OrderState => {
    const response: OrderState = {
      ..._state,
      list: {
        ...successStatus,
        data: order.data,
      },
    };

    return response;
  }),

  on(createOrderFail, (_state: OrderState, data: any): OrderState => {
    const response: OrderState = {
      ..._state,
      list: {
        ...failStatus,
        message: data.message,
      },
    };

    return response;
  }),

  // CREATE ORDER HANDLERS
  on(getOrder, (_state: OrderState): OrderState => {
    const response: OrderState = {
      ..._state,
      currentOrder: {
        ...loadingStatus,
      },
    };

    return response;
  }),

  on(getOrderSuccess, (_state: OrderState, order): OrderState => {
    const response: OrderState = {
      ..._state,
      currentOrder: {
        ...successStatus,
        data: order.data,
      },
    };

    return response;
  }),

  on(getOrderFail, (_state: OrderState, data: any): OrderState => {
    const response: OrderState = {
      ..._state,
      currentOrder: {
        ...failStatus,
        message: data.message,
      },
    };

    return response;
  }),
);
